// Components
const SwitchPet = () => import(/* webpackPrefetch: true, webpackChunkName: 'switch-pet' */ '@/app/views/main-view/_shared/_components/switch-pet/switch-pet.vue');
const NotificationComponent = () => import(/* webpackPrefetch: true, webpackChunkName: 'notification-component' */ '@/app/views/main-view/_shared/_components/notification-component/notification-component.vue');
const DropdownMenu = () => import(/* webpackPrefetch: true, webpackChunkName: 'notification-component' */ '@/app/views/main-view/_shared/_utilities/profile-dropdown-menu/profile-dropdown-menu.vue');

// Mixins
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';
import { notificationMixins } from '@/app/mixins/components/notification-mixins.js';
import { comingSoonMixins } from '@/app/mixins/utils/coming-soon-mixins';
import { switchPetMixins } from '@/app/mixins/modules/switch-pet-mixins';

// Constants
import { GA } from '@/app/constants/ga-constants';

// Services
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
	name: 'TheHeader',
	mixins: [
		userMixins,
		GoogleAnalyticsMixins,
		notificationMixins,
		comingSoonMixins,
		toastMessageMixins,
		switchPetMixins
	],
	components: {
		SwitchPet,
		NotificationComponent,
		DropdownMenu
	},
	data() {
		return {
            hasProfileImage: false
		}
	},
	methods: {
		toggleSideBar() {
			this.$store.commit('toggleSideBar');
		},
		sendUserSettingAnalytics(type) {
			let action = '';
			let label = '';

			switch(type) {
				case 'profile':
					action = GA.USER_SETTINGS.PROFILE_BUTTON.ACTION;
					label = GA.USER_SETTINGS.PROFILE_BUTTON.LABEL;
					break;

				case 'upgrade':
					action = GA.USER_SETTINGS.UPGRADE_BUTTON.ACTION;
					label = GA.USER_SETTINGS.UPGRADE_BUTTON.LABEL;
					break;

				case 'settings':
					action = GA.USER_SETTINGS.SETTINGS_BUTTON.ACTION;
					label = GA.USER_SETTINGS.SETTINGS_BUTTON.LABEL;
			}

			this.sendEventTrackingToGA(action, GA.USER_SETTINGS.CATEGORY, label);
		},
		sendNotificationsAnalytics() {
			this.sendEventTrackingToGA(GA.NOTIFICATIONS.NOTIFICATION_DROPDOWN.ACTION, GA.NOTIFICATIONS.CATEGORY, GA.NOTIFICATIONS.NOTIFICATION_DROPDOWN.LABEL);
		},
		addAnotherPet() {
			this.$emit('addAnotherPet');
		}
	}
}